import { ApiClient, TokenAdd } from "@/services/apiClient/ApiClient";
import { Category_Schema, type CategoryId } from "@/services/collection/categories/categoriesSchema";
import type { Category } from "@/services/collection/categories/categoriesTypes";

// Load them only once during session
let cache_all: Promise<Category[]> | undefined = undefined;

export const fetchAllCategories = async (): Promise<Category[]> => {
  if (cache_all === undefined) {
    const url = "api-public/collection/category";
    cache_all = ApiClient.getPublic<Category[]>(url, {}, TokenAdd.IfAvailable).then(({ data }) => Category_Schema.array().parse(data));
  }

  return cache_all;
};

export const fetchCategoryById = async (id: CategoryId): Promise<Category> =>
  fetchAllCategories().then((categories) => {
    const category = categories.find((category) => category.id === id);
    if (category === undefined) {
      throw new Error(`Category not found: #${id} (${categories.length} categories available)`);
    } else {
      return category;
    }
  });

export const fetchCategoryByUrl = async (slug: string): Promise<Category | undefined> => fetchAllCategories().then((categories) => categories.find((category) => category.url === slug));
